// PARTNERS
export const GOOGLE_MY_BUSINESS = 'GOOGLE_MY_BUSINESS';
export const FACEBOOK = 'FACEBOOK';
